import { useAtomValue } from 'jotai';

import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';
import { mappedLocales } from '@core/Utils/Intl/MappedLocales';
import { Button } from '@gds/Button/Button';
import { Input } from '@gds/Input/Input';
import { Slider } from '@gds/Slider/Slider';
import { Typography } from '@gds/Typography/Typography';

import { useRangeFilters } from 'Hooks/SearchFilters/UseRangeFilters';

import type { FilterControlBaseProps } from '../../FilterPanel.entity';
import { RANGE } from './MileageFilter.constants';

import styles from './MileageFilter.module.css';

type MileageFilterProps = FilterControlBaseProps;

export const MileageFilter = ({ strings, locale }: MileageFilterProps) => {
  const minVal = RANGE[0].toString();
  const maxVal = RANGE[RANGE.length - 1].toString();
  const { totalCount } = useAtomValue(aggregationsAtom);

  const { gteInputProps, lteInputProps, sliderProps, canReset, reset } = useRangeFilters(
    'mileage',
    RANGE,
    [minVal, maxVal],
  );

  return (
    <section className={styles.mileageFilter}>
      <Typography className={styles.infoLine} variant="subheading4">
        {strings.mileageInfoLine}
      </Typography>
      <div className={styles.minMaxInputs}>
        <Input {...gteInputProps} label={strings.min} type="number" min={0} />
        <Input {...lteInputProps} label={strings.max} type="number" max={maxVal} />
      </div>
      <div className={styles.auxInfo}>
        <Typography Component="span" className={styles.resultCount} variant="caption2">
          ( {totalCount.toLocaleString(mappedLocales[locale])})
        </Typography>
        <Button
          color="secondary"
          disabled={!canReset()}
          onClick={() => reset()}
          size="small"
          variant="link"
        >
          {strings.reset}
        </Button>
      </div>
      <Slider {...sliderProps} className={styles.priceRangeSlider} dataTestId="mileage-slider" />
    </section>
  );
};
